<template>
  <div class="pd-embed-control" :class="{'pd-embed-contorl-disabled':!editable}">
    <template v-if="editable">
      <div class="flex-wrap pd-embed-value" style="padding:0 8px;cursor:pointer;" @click="modalFileSelector=true">
        {{value?value.length+'个文件 (点击编辑)':'上传文件'}}
      </div>
    </template>
    <template v-else>
        {{value?value.length+'个文件':'不可用'}}
    </template>

    <Modal v-model="modalFileSelector" footer-hide title="上传图片">
      <div>
        <BaseImageUpload v-model="images" @input="$emit('input',images)" />
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: [],
      modalFileSelector: false,
    };
  },
  watch: {
    value: {
      handler(v) {
        console.log(v, typeof v, Array.isArray(v));
        if (Array.isArray(v)) {
          this.images = [...v];
        } else {
          this.images = [];
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    imageMode() {
      return this.opt.image;
    },
    opt() {
      return this.option || {};
    },
  },
  props: ['value', 'editable', 'option'],
};
</script>

<style>

</style>
